import { render, staticRenderFns } from "./metadata-card.vue?vue&type=template&id=76a9c3c6"
import script from "./metadata-card.vue?vue&type=script&lang=js"
export * from "./metadata-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports